<script lang="ts">
  import { ui } from "../lib/stores/ui.svelte.js";
  import Sheet from "./Sheet.svelte";

  const request = $derived(ui.confirmRequest);
</script>

{#if request}
  <Sheet title={request.title} onclose={() => request.resolve(false)} width={420}>
    <div class="body">
      <h2>{request.title}</h2>
      <p class="t2">{request.message}</p>
      <div class="actions">
        <button type="button" class="btn btn-ghost" onclick={() => request.resolve(false)}>Abbrechen</button>
        <button
          type="button"
          class="btn {request.danger ? 'btn-danger' : 'btn-primary'}"
          onclick={() => request.resolve(true)}>{request.confirmLabel}</button
        >
      </div>
    </div>
  </Sheet>
{/if}

<style>
  .body {
    padding: 4px 8px 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  h2 {
    font-size: 22px;
  }
  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
  }
</style>
